'use client';
import React, { useState } from 'react';
import './MenuIcon.css';

const MenuIcon = ({ isOpen }: { isOpen: boolean }) => {
  // const [isOpen,setIsOpen] = useState(false)
  return (
    <div
      id="nav-icon4"
      className={`${
        isOpen ? 'open' : ''
      } flex flex-col items-center justify-between `}
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default MenuIcon;
